export default "__VITE_ASSET__DvZeMYv$__"